import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input']

  submit() {
    ga('send', 'event', 'search', this.inputTarget.value)
  }
}
